import { useEffect } from 'react';
import Select from 'common/components/form/inputs/Select';
import { components } from 'react-select';
import { useSelector } from 'react-redux';
import { useActions } from 'utils/hooks';
import * as listActions from 'store/lists/actions';

const AirportTypeSelector = ({ isMulti, filter, value, label, onChange }) => {
  const [fetchListOptions] = useActions([listActions.fetchListOptions]);
  const airportTypes = useSelector(state => state.lists['airport-types']);

  useEffect(() => {
    if (!airportTypes.options.length && !airportTypes.isFetching) {
      fetchListOptions('airport-types');
    }
  }, []);

  return (
    <Select
      label={label}
      placeholder={'Select value'}
      components={{ MultiValueLabel, SingleValue }}
      getOptionValue={option => option.label}
      getOptionLabel={option => option.name}
      value={filter ? (filter.value && Array.isArray(filter.value) ? filter.value : []) : value}
      options={airportTypes.options}
      isMulti={isMulti}
      onChange={selected =>
        onChange({
          data: selected ? selected : [],
          value: selected ? (isMulti ? selected : selected) : ''
        })
      }
      isClearable
    />
  );
};

const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>
    <div className="d-flex align-items-center">
      <div className={`d-inline-block ms-1`}>{props.data.name}</div>
    </div>
  </components.SingleValue>
);

const MultiValueLabel = ({ children, ...props }) => {
  return (
    <components.MultiValueLabel {...props}>
      <div className="d-flex align-items-center">
        <div className={`d-inline-block ms-1`}>{props.data.name}</div>
      </div>
    </components.MultiValueLabel>
  );
};

export default AirportTypeSelector;
